import { render, staticRenderFns } from "./OrdineComponenti.vue?vue&type=template&id=3d670391"
import script from "./OrdineComponenti.vue?vue&type=script&lang=js"
export * from "./OrdineComponenti.vue?vue&type=script&lang=js"
import style0 from "./OrdineComponenti.vue?vue&type=style&index=0&id=3d670391&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports